export default "__VITE_ASSET__wF$Wk55a__"